module.exports = __webpack_public_path__ + "static/media/sik_montage.2c0365bd.jpg";